import React, { PropsWithChildren, useEffect } from "react";
import { generateClassName } from "../../../hooks/useAttributes";
import Icon from "../icons/Icon";
import "./AccordionPage.css";

interface Props {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actionItems?: React.ReactNode;
  background?: string;
  hover?: string;
  onToggle?: (open: boolean) => void;
  open?: boolean;
}

function AccordionPage(props: PropsWithChildren<Props>) {

  const {
    title,
    children,
    background,
    subtitle,
    actionItems,
    open,
    hover
  } = props;

  const [isOpen, setIsOpen] = React.useState(open || false);

  useEffect(() => {
    setIsOpen(open || false);
  }, [open]);

  const toggle = () => {
    const next = !isOpen;

    props.onToggle?.(next);
    setIsOpen(next);
  }

  return (
    <div className="d-flex flex-column" style={{
      ["--accordion-hover" as any]: hover
    }}>
      <div className="d-flex flex-column gap-3">
        <div
          className={generateClassName("transition w-100 d-flex flex-column accordion-expander", {
            value: isOpen,
            onTrue: "accordion-expander-open"
          })}
          style={{ background }}
        >
          <div className="w-100 d-flex flex-row align-items-center justify-content-between pt-3 ps-3 gap-1">
            <div className="d-flex flex-row align-items-center gap-2 w-100 "
              onClick={toggle}
            >
              {title}
            </div>
            {actionItems}
            <div
              onClick={toggle}
              className="ms-2 pe-4"
            >
              <Icon
                icon="chevron-right"
                size={10}
                className="accordion-expander-icon transition d-flex"
              />
            </div>
          </div>
          <div className="pb-3 ps-4 w-100 pe-3" onClick={toggle}>
            {subtitle}
          </div>
        </div>
        {
          isOpen && children
        }
      </div>
    </div>
  )
}

function AccordionPageTitle(props: PropsWithChildren<{}>) {

  const {
    children
  } = props;

  return (
    <span className="accordion-page-title">
      {children}
    </span>
  )
}

export { AccordionPage, AccordionPageTitle };
